var Long = require("long");

export default class DateConverter
{
    /* * * * * * *
     * This converter is now only needed for ChatMessage timestamps, 
     * which are generated by the C# backend via the DateTime class, 
     * which has a different representation from JS Date.
     * * * * * * *
     */

    public static readonly millisecondsOffset = 62135596800000;

    public static binaryToEpoch(input : string) : string
    {
        //console.log('from: ' + input);
        let lint = Long.fromString(input)
            .divide(10000) // ticks to milliseconds
            .subtract(DateConverter.millisecondsOffset);
        //console.log('to: ' + lint.toString());
        return lint.toString();
    }

    public static binaryToDate(input : string, fixBC : boolean = true) : Date
    {
        let ms = this.binaryToEpoch(input);
        let d = new Date();
        d.setTime(Number.parseFloat(ms));
        if (fixBC && (d.getUTCFullYear() > 4999))
        {
            d.setUTCFullYear(-1 * (9999 - d.getUTCFullYear()));
        }
        return d;
    }

    public static epochToBinary(input : number) : string
    {
        let lint = Long.fromNumber(input)
            .add(DateConverter.millisecondsOffset)
            .multiply(10000); // ticks to milliseconds
        return lint.toString();
    }

    public static dateToBinary(input : Date, fixBC : boolean = true) : string
    {
        let avoidSideEffects = new Date(input.valueOf());
        if (fixBC && (input.getUTCFullYear() <= 0))
        {
            avoidSideEffects.setUTCFullYear(9999 + avoidSideEffects.getUTCFullYear());
        }
        let ms = avoidSideEffects.getTime();
        return this.epochToBinary(ms);
    }

    /** checks if it's a string, checks bounds of Date object, etc */
    public static serverInputToDate(input : any)
    {
        let output;
        if (typeof input === 'number')
        {
            output = input;
        }
        else
        {
            output = Number.parseInt(input);
            if (isNaN(output))
            {
                output = 0;
            }
        }
        
        // fit into Date bounds
        if (output > 8640000000000000)
        {
            output = 8640000000000000;
        }
        else if (output < -8640000000000000)
        {
            output = -8640000000000000;
        }

        return new Date(output);
    }
}